import { useEffect, useState } from 'react';

export default function useUserLocation(enabled, pollingInterval = 5000) {
  const [location, setLocation] = useState(null);

  useEffect(() => {
    if (!enabled) return;

    const updateLocation = () => {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setLocation({
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude
          });
        },
        (err) => console.error('Error obteniendo ubicación:', err),
        { enableHighAccuracy: true }
      );
    };

    updateLocation();
    const interval = setInterval(updateLocation, pollingInterval);
    return () => clearInterval(interval);
  }, [enabled , pollingInterval]);

  return location;
}
